import React from 'react'
const AppRedirecting = () => {
  return <p>Redirecting...</p>
}

export default AppRedirecting
